import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "@fontsource/inter"
import "@fontsource/inter/400.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installCsrfInterceptor } from './components/utils/csrf';

// Install the global axios CSRF interceptor before any service module fires
// its first request. Reads the non-HttpOnly ``payassist_csrf`` cookie set
// alongside the encrypted session and copies it into ``X-CSRF-Token`` on
// every POST/PUT/PATCH/DELETE.
installCsrfInterceptor();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
